import styled, { css } from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { PLAYOFF_SERIES_SMALL_SCREEN_QUERY, PLAYOFF_SERIES_SMALLEST_SCREEN_QUERY } from '../../../../styles';

import { determineGameInfoChipColor } from './utils';

export const TeamMatchupContainer = styled.div`
    width: 100%;
    display: flex;
    padding: 8px;
    justify-content: space-between;
    align-items: center;

    ${PLAYOFF_SERIES_SMALLEST_SCREEN_QUERY} {
        width: 288px;
    }

    ${PLAYOFF_SERIES_SMALL_SCREEN_QUERY} {
        width: 328px;
    }

    ${BaseStyle.Mixins.screenSizes.large} {
        padding: 0;
        width: 466px;
    }
`;

export const TeamContainer = styled.div<{ $fade: boolean; $isRight?: boolean }>`
    opacity: ${({ $fade }) => ($fade ? 0.5 : 1)};
    display: flex;
    align-items: center;
    gap: 8px;
    ${({ $isRight }) =>
        $isRight
            ? css`
                  justify-content: flex-start;
                  flex: 1 0 0;
                  text-align: start;
              `
            : css`
                  justify-content: flex-end;
                  text-align: end;
                  flex: 1 1 0;
              `}
`;

export const TeamName = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle2}
`;

export const TeamLogoContainer = styled.div`
    width: 48px;
    height: 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .team-display {
        img {
            height: 48px;
            width: 48px;

            ${PLAYOFF_SERIES_SMALLEST_SCREEN_QUERY} {
                width: 32px;
                height: 32px;
            }
        }
    }
`;

export const Scoreboard = styled.div`
    width: 115px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    text-align: center;
`;

export const TeamScore = styled.div<{ $fade: boolean }>`
    ${BaseStyle.Mixins.fontStyles.desktop.subtitle1}
    width: 32px;
    height: 32px;
    opacity: ${({ $fade }) => ($fade ? 0.5 : 1)};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const FinalGameStatus = styled.div`
    ${BaseStyle.Mixins.fontStyles.desktop.body4}
    white-space: nowrap;
`;

export const GameInfoChip = styled.div<{ $isGameCritical?: boolean; $isGameLive: boolean }>`
    ${BaseStyle.Mixins.fontStyles.ui['12b']}
    border-radius: 4px;
    background: ${({ $isGameLive, $isGameCritical, theme }) =>
        determineGameInfoChipColor($isGameLive, $isGameCritical || false, theme)};
    padding: 4px 8px;
    white-space: nowrap;
`;
